import React from 'react';

import './TopEventsRank.css';
import { cn } from '@wwe-portal/ui/lib/lib';

function TopEventsRank({ rank, place, isCircle = true }) {
  const placeString = (i) => {
    const j = i % 10,
      k = i % 100;
    if (j === 1 && k !== 11) {
      return i + 'st';
    }
    if (j === 2 && k !== 12) {
      return i + 'nd';
    }
    if (j === 3 && k !== 13) {
      return i + 'rd';
    }
    return i + 'th';
  };

  return isCircle ? (
    <div
      className={cn(
        'top-events-rank mb-[15px] flex items-center justify-center rounded-full',
        place
      )}
    >
      <span className="text-text700 text-sm font-semibold">
        {placeString(rank)}
      </span>
    </div>
  ) : (
    <div className="mb-[15px] flex items-center justify-center">
      <span className="text-text500 bg-back200 rounded-[6px] px-[10px] py-[5px] text-xs font-semibold">
        {placeString(rank)}
      </span>
    </div>
  );
}

export default TopEventsRank;
